import { FilterBar } from '@/components/filters/FilterBar';
import { SearchInput } from '@/components/filters/SearchInput';
import { useAdminVaults } from '@/hooks/useAdminVaults';
import { useState } from 'react';
import { VaultsTable } from '../components/VaultsTable';
import { VaultStorageStats } from '../components/VaultStorageStats';

export function VaultsOverviewPage() {
  const [search, setSearch] = useState('');
  const { data, isLoading } = useAdminVaults({ search, limit: 25 });
  const vaults = data?.data || [];

  return (
    <div className="space-y-6">
      <div><h1 className="text-xl font-bold text-neutral-900 dark:text-neutral-100">Coffres-forts</h1><p className="text-sm text-neutral-500">Gestion des coffres-forts numériques</p></div>
      <VaultStorageStats />
      <FilterBar>
        <div className="w-72"><SearchInput value={search} onChange={setSearch} placeholder="Rechercher un coffre..." /></div>
      </FilterBar>
      <VaultsTable data={vaults} loading={isLoading} />
    </div>
  );
}
